export enum ReinsurancesPdpType {
  securedPayement = 'securedPayement',
  freeDelivery = 'freeDelivery',
  freeReturn = 'freeReturn',
  CLIENT_SERVICE = 'CLIENT_SERVICE',
  EXTENDED_WARRANTY = 'EXTENDED_WARRANTY',
  REPAIRABILITY = 'REPAIRABILITY',
  WARRANTY = 'WARRANTY'
}
